import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PorIconDirective } from '@por/shared/ui/icon-lib';

@Component({
    selector: 'apx-dropdown-item',
    standalone: true,
    imports: [CommonModule, PorIconDirective],
    templateUrl: './dropdown-option-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApxDropdownOptionItemComponent {
    @Input() label: string | null = null;
    @Input() value: string | null = null;
    @Input() lastItem = false;
    @Input() isFocused = false;
    @Input() isSelected = false;
    @Output() readonly itemClicked = new EventEmitter<string | null>();
}
